import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { forwardRef, useEffect, useCallback, ReactNode } from 'react';
import { LazyMotion, domAnimation, m } from 'framer-motion';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import track from '../../utils/analytics';

const Page = forwardRef(({ children, title = '', ...other }, ref) => {
  const { pathname } = useLocation();
  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: pathname,
    });
  }, [pathname]);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  return (
    <LazyMotion features={domAnimation}>
      <m.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <Box ref={ref} {...other}>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          {children}
        </Box>
      </m.div>
    </LazyMotion>
  );
});

export default Page;
